import { TOTEM_STATS, type PlayerState, type TotemKind } from '@orb/sim';

export type { TotemKind } from '@orb/sim';

/** `period`: the totem's charge — ascend's seconds between ascensions, shatter's between broken spheres. */
export const TOTEMS: Record<TotemKind, { name: string; detail: string; color: number; rate: number; power: number; badge: string; period?: number }> = {
  wind: { name: 'Тотем вітру', detail: '+15% швидкості атак усіх ваших сфер. Діє постійно, поки тотем встановлено.', color: 0x68d5d0, rate: TOTEM_STATS.wind.rate, power: 1, badge: '+15% темпу' },
  might: { name: 'Тотем сили', detail: '+20% шкоди ваших сфер, включно з отрутою та гравітаційним виром. Діє постійно.', color: 0xff9565, rate: 1, power: TOTEM_STATS.might.power, badge: '+20% шкоди' },
  shatter: { name: 'Тотем знищення', detail: `Раз на ${TOTEM_STATS.shatter.period} с можна розбити будь-яку свою сферу: перетягніть її на тотем — лунка звільниться для нового призову.`, color: 0xe2485e, rate: 1, power: 1, badge: `розбити сферу · ${TOTEM_STATS.shatter.period} с`, period: TOTEM_STATS.shatter.period },
  ascend: { name: 'Тотем піднесення', detail: `Кожні ${TOTEM_STATS.ascend.period} с підносить на рівень одну з ваших сфер найнижчого рівня. Легендарні не зачіпає.`, color: 0xf2c46a, rate: 1, power: 1, badge: `+1 рівень · ${TOTEM_STATS.ascend.period} с`, period: TOTEM_STATS.ascend.period },
};

/** A read-only window onto one player's equipped totem in the simulation. */
export class Totems {
  constructor(private readonly player: () => PlayerState) {}
  get kind(): TotemKind { return this.player().totem; }
  get version() { return this.player().totemVersion; }
  get rate() { return TOTEM_STATS[this.kind].rate; }
  get power() { return TOTEM_STATS[this.kind].power; }
  get period() { return TOTEM_STATS[this.kind].period; }
  /** 0…1 fill of the current cycle; 0 for passive totems. */
  get progress() { const p = this.period; return p ? Math.min(1, this.player().totemCharge / p) : 0; }
}
